var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.handleModalCloseAll,
          expression: "handleModalCloseAll"
        }
      ],
      class: _vm.bemBlockMod({ open: _vm.isModalOpen })
    },
    [
      _vm.buttonText
        ? _c(
            "button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.isBreakpointMobile &&
                    (!_vm.isOpen || !_vm.hideButtonOnOpen),
                  expression:
                    "isBreakpointMobile && (!isOpen || !hideButtonOnOpen)"
                }
              ],
              class: [_vm.bemElement("btn"), "btn", "btn--cta"],
              on: { click: _vm.handleToggleModal }
            },
            [_vm._v("\n    " + _vm._s(_vm.buttonText) + "\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          class: [
            _vm.bemElement("content"),
            _vm.noPadding ? _vm.bemElement("content-no-padding") : "",
            _vm.showModalClose && _vm.isBreakpointMobile
              ? _vm.bemElement("content-modal-close")
              : ""
          ]
        },
        [
          _vm.showModalClose
            ? _c("button", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isBreakpointMobile,
                    expression: "isBreakpointMobile"
                  }
                ],
                class: [
                  _vm.bemElement("btn-close", { hidden: !_vm.isModalOpen }),
                  "btn-close"
                ],
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.handleModalCloseAll($event)
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm._t("default")
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }